import { Form, Input } from "antd";

export const UploadFileForm = ({form, accept, onSelectFile}) => {
  function handleChangeFile(event) {
    const file = event.target.files[0];
    onSelectFile(file)
  }

  const content = (
    <Form initialValues={{}} form={form}>
      <Form.Item name="fileName" label="File" rules={[{ required: true }]}>
        <Input type="file" accept={accept} onChange={handleChangeFile} />
      </Form.Item>
    </Form>
  );

  return content;
};

